import Cacheable from './Cacheable';
import {ICacheable} from '../../@interfaces/classes/Cacheable/ICacheable';
import {ICache} from '../../@interfaces/classes/Cacheable/ICache';

export default class Cache<TCache> extends Cacheable<TCache> implements ICache<TCache> {
    hasCache(key: string): boolean {
        return super.hasCache(key);
    }

    getCache(key: string): TCache | null {
        return super.getCache(key);
    }

    setCache(key: string, value: TCache): ICacheable {
        return super.setCache(key, value);
    }

    forget(key: string): void {
        return super.forget(key);
    }

    remember<TResult>(
        key: string,
        resultProvider: () => TResult,
        shouldInvalidate?: (cachedResult: TResult) => boolean
    ): TResult {
        return super.remember(key, resultProvider, shouldInvalidate);
    }

    forgetRemember(key: string): void {
        return super.forgetRemember(key);
    }
}
